import {createRouter, createWebHistory} from 'vue-router'
import store from '@/store/index';

function lazyLoad(view) {
    return () => import(`@/views/${view}.vue`)
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: lazyLoad('Home'),
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: lazyLoad('AboutUs')
    },
    {
        path: '/company-profile',
        name: 'CompanyProfile',
        component: lazyLoad('CompanyProfile'),
    },
    {
        path: '/gv-group',
        name: 'GVGroup',
        component: lazyLoad('GVGroup'),
    },
    {
        path: '/membership-registration',
        name: 'MembershipRegistration',
        component: lazyLoad('MembershipRegistration'),
    },
    {
        path: '/businesses-registration',
        name: 'BusinessesRegistration',
        component: lazyLoad('BusinessesRegistration'),
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: lazyLoad('ContactUs'),
    },
    {
        path: '/login',
        name: 'Login',
        component: lazyLoad('Login'),
    },
    {
        path: '/admin',
        redirect: '/admin/members',
    },
    {
        path: '/admin/:type',
        name: 'Admin',
        component: lazyLoad('Admin'),
    },
    {
        path: '/gv-learning',
        name: 'GVLearning',
        component: lazyLoad('GVLearning'),
    },
    {
        path: '/store',
        name: 'Store',
        component: lazyLoad('Store'),
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: lazyLoad('Dashboard'),
    },
    {
        path: '/categories',
        name: 'Categories',
        component: lazyLoad('Categories'),
    },
    {
        path: '/my-courses',
        name: 'MyCourses',
        component: lazyLoad('MyCourses'),
    },
    {
        path: '/category/:id',
        name: 'Category',
        component: lazyLoad('Category'),
        props: true,
    },
    {
        path: '/lesson/:id',
        name: 'Lesson',
        component: lazyLoad('Lesson'),
        props: true,
    },
    {
        path: '/course',
        name: 'Course',
        component: lazyLoad('Course'),
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = store.getters["auth/loggedIn"];

    if ((to.name === 'Dashboard' || to.name === 'Admin' || to.name === 'MyCourses') && !loggedIn) {
        next('/login')
    } else {
        next();
    }
});

export default router
